import { render, staticRenderFns } from "./ServicosBox.vue?vue&type=template&id=0a04e915&"
import script from "./ServicosBox.vue?vue&type=script&lang=js&"
export * from "./ServicosBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports